import { isEditorMode } from 'src/game/minigame/match2-timestep/editor/editor.utils';
import { getNextScene } from 'src/lib/stateUtils';
import { State } from 'src/state';

export function shouldShowHeader(state: State) {
  return getNextScene() !== 'debut' && state.ui.showHeader && !isEditorMode();
}

export function shouldShowFooter(state: State) {
  return (
    !state.care.currentCareAction &&
    getNextScene() !== 'debut' &&
    state.ui.showFooter &&
    !isEditorMode()
  );
}
